<template>
  <div>
    <b-card
      no-body
      class="mb-1"
      v-for="(item, index) in qualifications"
      :key="uniqueId(item.id)"
    >
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button
          block
          v-b-toggle="'accordion-qualification-' + index"
          variant="info"
        >
          <span v-if="!item.isCompleted">Current Qualification</span>
          <span v-if="item.isCompleted">Qualification {{getDate(item.createdDateTime)}}</span>
        </b-button>
      </b-card-header>
      <b-collapse
        :id="'accordion-qualification-' + index"
        visible
        accordion="accordion"
        role="tabpanel"
      >
        <b-card-body>
          <b-card-text>
            <CompanyClientEntry
              :initialQualification="item"
              :lookups="lookups"
              :index="parseInt(index)"
              :company="company"/>

          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import CompanyClientEntry from "@/components/company/client/CompanyClientEntry.vue";

import { format } from 'date-fns'

export default {
  components: { CompanyClientEntry },
  props: {
    company: Object,
    lookups: Object,
    initialQualifications: Array
  },
  mounted() {
    this.qualifications = {...this.initialQualifications};
  },
  watch: {
    initialQualifications: function() {

      if(this.initialQualifications.length> 0) {
        this.uniqueIdStart += 1;
      }

      this.qualifications = {...this.initialQualifications};
    }
  },
  data() {
    return {
      qualifications: null,
      uniqueIdStart: 0
    };
  },
  methods: {
    getDate(date) {
      if(date == null) return "";
      return format(new Date(date), "dd/MM/yyyy HH:mm")
    },
    uniqueId(id) {
      return this.uniqueIdStart + '-' + id;
    }
  }
};
</script>


<style scoped>
.table {
  font-size: 0.85em;
}

.label {
  text-align: right;
}
.label > label {
  margin-top: 6px;
}
</style>

